// extracted by mini-css-extract-plugin
export default {"containerModal":"ModalOfZone_containerModal__i92Qu","section":"ModalOfZone_section__aY6gm","rowButton":"ModalOfZone_rowButton__7FAh4","button":"ModalOfZone_button__pd2rh"};